<template>
  <div class="table-page-search-wrapper">
    <a-form layout="inline">
      <a-form layout="inline">
        <a-row :gutter="48"> <a-col :md="6" :sm="24">
          <a-form-item label="类路径">
            <a-input placeholder="请输入类路径" v-model="searchModel.clazz"/>
          </a-form-item>
        </a-col><a-col :md="6" :sm="24">
          <a-form-item label="占位符">
            <a-input placeholder="请输入占位符" v-model="searchModel.code"/>
          </a-form-item>
        </a-col><a-col :md="6" :sm="24">
          <a-form-item label="方法名">
            <a-input placeholder="请输入方法名" v-model="searchModel.method"/>
          </a-form-item>
        </a-col><template v-if="advanced"><a-col :md="6" :sm="24">
          <a-form-item label="优先级">
            <a-input placeholder="请输入优先级" v-model="searchModel.priority"/>
          </a-form-item>
        </a-col><a-col :md="6" :sm="24">
          <a-form-item label="替换规则">
            <a-input placeholder="请输入替换规则" v-model="searchModel.sentence"/>
          </a-form-item>
        </a-col><a-col :md="6" :sm="24">
          <a-form-item label="占位符类型">
            <a-select v-model="searchModel.type" :allowClear="true" >
              <a-select-option v-for="(item,index) in typeList" :key="index">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col><a-col :md="6" :sm="24">
          <a-form-item label="值">
            <a-input placeholder="请输入值" v-model="searchModel.value"/>
          </a-form-item>
        </a-col></template><a-col :md="6" :sm="24">
          <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
            <a-button type="primary" @click="search">查询</a-button>
            <a-button style="margin-left: 8px" @click="clearSearch">重置</a-button>
            <a @click="toggleAdvanced" style="margin-left: 8px" v-if="true" v-show="showExpend">
              {{ advanced ? '收起' : '展开' }}
              <a-icon :type="advanced ? 'up' : 'down'" v-if="true" v-show="showExpend"/></a>
          </span>
        </a-col>
        </a-row>
      </a-form>
    </a-form>
  </div>
</template>

<script>

export default {
  name: 'PlaceholderSearchForm',
  mounted () {
  },
  data () {
    return {
      showExpend: false,
      typeList: [
        {
          label: '常量',
          value: 1
        },
        {
          label: '工具类方法',
          value: 2
        }
      ],
      searchModel: {
      },
      advanced: false// 是否展开
    }
  },
  methods: {
    // 搜索框展开
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 点击查询按钮
    search () {
      this.$emit('setSearchCondition', this.searchModel)
    },
    // 点击复位按钮
    clearSearch () {
      this.searchModel.clazz = ''
      this.searchModel.code = ''
      this.searchModel.method = ''
      this.searchModel.priority = ''
      this.searchModel.sentence = ''
      this.searchModel.type = ''
      this.searchModel.value = ''

      this.$emit('clearSearch', this.searchModel)
    }
  }
}
</script>

<style scoped>

</style>
